var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-radio-group',{attrs:{"value":_vm.templateType},on:{"change":_vm.onChange}},_vm._l((_vm.templateList),function(item){return _c('a-radio-button',{key:item.key,attrs:{"value":item.key}},[_vm._v("\n    "+_vm._s(item.value)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }